  /**
   * 格式化电话号码，将中间几位替换为星号
   * @param {string} phoneNumber - 原始电话号码
   * @returns {string} 格式化后的电话号码
   */
  export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    
    // 移除所有非数字字符
    const cleaned = phoneNumber.replace(/\D/g, '');
    
    // 根据不同长度进行格式化
    if (cleaned.length === 11) {
      // 手机号码：138****1234
      return cleaned.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    } else if (cleaned.length === 8) {
      // 8位固话：1234****
      return cleaned.replace(/(\d{4})\d{4}/, '$1****');
    } else if (cleaned.length >= 10 && cleaned.length <= 12) {
      // 带区号的固话：010-1234**** 或 0755-1234****
      const areaCodeLength = cleaned.length - 8;
      const areaCode = cleaned.substring(0, areaCodeLength);
      const mainNumber = cleaned.substring(areaCodeLength);
      return `${areaCode}-${mainNumber.replace(/(\d{4})\d{4}/, '$1****')}`;
    } else {
      // 其他格式的电话号码，保留前3位和后4位，中间用星号
      if (cleaned.length <= 7) {
        return cleaned; // 太短的号码不处理
      }
      const visibleStart = cleaned.substring(0, 3);
      const visibleEnd = cleaned.substring(cleaned.length - 4);
      const stars = '*'.repeat(cleaned.length - 7);
      return `${visibleStart}${stars}${visibleEnd}`;
    }
  };